import { Popover, Transition } from '@headlessui/react'
import React from 'react'
import { cn } from 'cn'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import useTheme from 'lib/theme/useTheme'

type MenuTransitionProps = {
  title: string
  children: React.ReactElement
  transparentHeader: boolean
}
const MenuTransition = ({
  title,
  children,
  transparentHeader
}: MenuTransitionProps) => {
  const { theme } = useTheme()
  const themedHeader = theme.page.themedBackground

  return (
    <div className="relative inline-block">
      <Popover>
        {({ open }) => (
          <>
            <Popover.Button
              className={cn(
                'group rounded-md inline-flex outline-none-mouse transition items-center',
                {
                  'text-white font-theme-body font-semibold px-5 py-2.5 rounded-theme-button bg-theme-button hover:bg-theme-button-hover':
                    themedHeader,
                  'duration-50 ease-in-out font-heading font-bold':
                    !themedHeader,
                  'hover:text-gray-50': !themedHeader && transparentHeader,
                  'text-gray-900 hover:text-orange-600':
                    !themedHeader && !transparentHeader
                }
              )}
            >
              <span>{title}</span>
              <ChevronDownIcon
                className={cn('ml-0.5 xl:ml-2 mt-0.5 h-5 w-5', {
                  'group-hover:text-gray-50':
                    !themedHeader && transparentHeader,
                  'text-gray-900 group-hover:text-orange-600':
                    !themedHeader && !transparentHeader
                })}
              />
            </Popover.Button>

            <Transition
              enter="transition ease-out duration-100"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
              show={open}
            >
              <Popover.Panel
                className="absolute z-10 left-1/2 -translate-x-1/2 mt-3 px-2 w-screen max-w-md sm:px-0"
                static
              >
                <div className="absolute mt-3 px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 z-20">
                  <div className="rounded-lg shadow-lg ring-1 ring-black/5 overflow-hidden">
                    <div className="z-20 relative flex flex-col bg-white py-4 px-2">
                      {children}
                    </div>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  )
}

export default MenuTransition
